import React, { useEffect, useRef, useState } from "react";
import play_icon from "../../assets/vw/svg/play_button.svg";
import pause_icon from "../../assets/vw/svg/pause-button.svg";

function AudioPlayer({ audioSrc }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    // Reinicia el estado del componente cuando cambia el audioSrc
    const audioElement = audioRef.current;
    setCurrentTime(0);
    setDuration(0);
    setIsPlaying(false);
  
    // Carga el nuevo audio
    audioElement.load();
  }, [audioSrc]);

  useEffect(() => {
    const audioElement = audioRef.current;
  
    const updateCurrentTime = () => {
      setCurrentTime(audioElement.currentTime);
    };
  
    const updateDuration = () => {
      setDuration(audioElement.duration);
    };
  
    const handleAudioEnd = () => {
      setIsPlaying(false); // Cambia el estado de isPlaying a false
    };
  
    audioElement.addEventListener("timeupdate", updateCurrentTime);
    audioElement.addEventListener("loadedmetadata", updateDuration);
    audioElement.addEventListener("ended", handleAudioEnd); // Escucha el evento ended
  
    return () => {
      audioElement.removeEventListener("timeupdate", updateCurrentTime);
      audioElement.removeEventListener("loadedmetadata", updateDuration);
      audioElement.removeEventListener("ended", handleAudioEnd); // Limpia el evento ended
    };
  }, []);

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    audioRef.current.volume = newVolume;
    setVolume(newVolume);
  };

  const handleProgressChange = (e) => {
    const newTime = e.target.value;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  useEffect(() => {
    const audioElement = audioRef.current;

    const updateCurrentTime = () => {
      setCurrentTime(audioElement.currentTime);
    };

    const updateDuration = () => {
      setDuration(audioElement.duration);
    };

    audioElement.addEventListener("timeupdate", updateCurrentTime);
    audioElement.addEventListener("loadedmetadata", updateDuration);

    return () => {
      audioElement.removeEventListener("timeupdate", updateCurrentTime);
      audioElement.removeEventListener("loadedmetadata", updateDuration);
    };
  }, []);

  // Calcula el porcentaje de progreso para el gradiente
  const progressPercent = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div className="custom-audio-player d-flex align-items-center">
      <audio ref={audioRef} src={audioSrc}></audio>
      <button
        className="btn btn-transparent p-0"
        onClick={(e) => {
            togglePlayPause();
        }}
      >
        <img
          src={isPlaying ? pause_icon : play_icon}
          alt={isPlaying ? "Pause" : "Play"}
          className="img-fluid"
        />
      </button>
      <span className="duration me-2">{formatTime(currentTime)}</span>
      <input
        type="range"
        min="0"
        max={duration}
        step="0.1"
        value={currentTime}
        onChange={handleProgressChange}
        className="form-range"
        style={{
          "--progress": progressPercent,
        }}
      />
      <span className="duration me-2">{formatTime(duration)}</span>
    </div>
  );
}

export default AudioPlayer;